export { BaseIcon } from './components/base-icon.mjs';
export { FlowbiteIcons } from './components/provider.mjs';
//# sourceMappingURL=index.mjs.map
